<template>
    <Stepper 
        :stepperSteps="stepperSteps" 
        @completed-step="completeStep" 
        @active-step="isStepActive" 
        :showNavigation="false"  
        @closeRefresh="closeRefresh"
      />
  </template>
  
  <script>
  import { Stepper } from '@/components/commons'
  import { SelectFile, SelectVehicle, ImportVehicle }  from './stepper-component'
  export default {
    name: 'New-Driver-Import',
    components: {Stepper},
    data(){
        return{
            stepperSteps: [
                 {
                    stepIcon: 'upload',
                    stepTitle: 'Upload File',
                    stepSequence: 'first',
                    stepComponent: SelectFile,
                    isCompleted: true,
  
                },
                {
                    stepIcon: 'users',
                    stepTitle: 'Select Vehicles',
                    stepSequence: 'second',
                    stepComponent: SelectVehicle,
                    isCompleted: false,
                },
                {
                    stepIcon: 'download',
                    stepTitle: 'Import',
                    stepSequence: 'third',
                    stepComponent: ImportVehicle,
                    isCompleted: false,
                },
            ],
            activeStep: 0,
        }
    },
     methods: {
        completeStep(payload) {
            this.stepperSteps.forEach((step) => {
                if (step.stepSequence === payload.stepSequence) {
                    step.isCompleted = true;
                }
            })
        },
        isStepActive(payload) {
            this.stepperSteps.forEach((step) => {
                if (step.stepSequence === payload.stepSequence) {
                    if(step.isCompleted === true) {
                        step.isCompleted = false;
                    }
                }
            })
        },
        closeRefresh(){ 
          this.$emit('closeRefresh')
        }
    },
    
  }
  </script>